var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mention-stats__links"},[_vm._l((_vm.items),function(item,index){return [_c('MentionStatsSummaryLinkItem',{key:index,attrs:{"entity":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }